import { FC } from "react";

import { Edit, Stop } from "shared/assets/icons";
import { IStatus } from "shared/types";
import { ButtonContainer, FancyButtonLink } from "shared/components";
import { copy } from "shared/assets";

interface Props {
  editCopy?: string;
  deleteCopy?: string;
  handleEdit?: () => void;
  handleDelete?: () => void;
  editTestId?: string;
  deleteTestId?: string;
}

export const EditDeleteLinks: FC<Props> = ({
  editCopy,
  deleteCopy,
  handleEdit,
  handleDelete,
  editTestId,
  deleteTestId,
}) => {
  if (!handleEdit && !handleDelete) return null;

  return (
    <ButtonContainer>
      {handleEdit && (
        <FancyButtonLink
          icon={Edit}
          onClick={handleEdit}
          data-testid={editTestId || "edit_link"}
        >
          {editCopy || copy.actions.edit}
        </FancyButtonLink>
      )}
      {handleDelete && (
        <FancyButtonLink
          icon={Stop}
          status={IStatus.error}
          data-testid={deleteTestId || "delete_link"}
          onClick={handleDelete}
        >
          {deleteCopy || copy.actions.delete}
        </FancyButtonLink>
      )}
    </ButtonContainer>
  );
};
